import { createAction, props } from '@ngrx/store';
import { ClassroomAnalytics, Facets, StudentAnalytics, ViewLevel } from '@wam/shared';
import { Params } from '@angular/router';
import { AssignmentResponse } from '@wap/catalog-v5';

export const load = createAction('[Assessments] Load');

export const continueLoad = createAction('[Assessments] Continue Load');

export const loadSuccess = createAction(
  '[Assessments] Load success',
  props<{ hits: ClassroomAnalytics[] | StudentAnalytics[]; totalHits: number }>(),
);

export const continueLoadSuccess = createAction(
  '[Assessments] Continue Load success',
  props<{ hits: ClassroomAnalytics[] | StudentAnalytics[]; totalHits: number }>(),
);

export const updateFacets = createAction(
  '[Assessments API] Update facets',
  props<{ facets: Facets }>(),
);

export const updateSelectedFacets = createAction(
  '[Assessments] Update selected facets',
  props<{ selectedFacets: Facets }>(),
);

export const updateLevel = createAction(
  '[Assessments] Update Level',
  props<{ level: ViewLevel }>(),
);

export const updateStoreFromRoute = createAction(
  '[Assessments] Update Store From Route',
  props<{ view: ViewLevel; queryParams: Params }>(),
);

export const loadStudentAssignments = createAction(
  '[Assessments] Load Student Assignments',
  props<{ userId: string }>(),
);

export const loadStudentAssignmentsSuccess = createAction(
  '[Assessments] Load Student Assignments Success',
  props<{ userId: string; assignments: AssignmentResponse[] }>(),
);

export const loadClassAssignments = createAction(
  '[Assessment] Load Class Assignments',
  props<{ classId: string }>(),
);

export const loadClassAssignmentsSuccess = createAction(
  '[Assessment] Load Class Assignments Success',
  props<{ classId: string; assignments: AssignmentResponse[] }>(),
);

export const loadSchoolAssignments = createAction(
  '[Assessment] Load School Assignments',
  props<{ schoolId: string }>(),
);

export const loadSchoolAssignmentsSuccess = createAction(
  '[Assessment] Load School Assignments Success',
  props<{ schoolId: string; grade: string; assignments: AssignmentResponse[] }>(),
);

export const createStudentAssignments = createAction(
  '[Assessment] Create Student Assignments',
  props<{ assignments: AssignmentResponse[] }>(),
);

export const createClassAssignments = createAction(
  '[Assessment] Create Class Assignments',
  props<{ assignments: AssignmentResponse[] }>(),
);

export const createSchoolAssignments = createAction(
  '[Assessment] Create School Assignments',
  props<{ assignments: AssignmentResponse[] }>(),
);

export const createStudentAssignmentsSuccess = createAction(
  '[Assessment] Create Student Assignments Success',
  props<{ assignments: AssignmentResponse[] }>(),
);

export const createClassAssignmentsSuccess = createAction(
  '[Assessment] Create Class Assignments Success',
  props<{ assignments: AssignmentResponse[] }>(),
);

export const createSchoolAssignmentsSuccess = createAction(
  '[Assessment] Create School Assignments Success',
  props<{ assignments: AssignmentResponse[] }>(),
);
